interface AppConfig {
    base_api_url: string;
}

class Locals {
    private static configData: AppConfig | null = null;

    public static config(): AppConfig {
        if (!Locals.configData) {
            const baseApiUrl = import.meta.env.DEV
                ? (import.meta.env.VITE_API_URL ?? 'http://localhost:3000')
                : (import.meta.env.VITE_API_URL ?? '');

            Locals.configData = {
                base_api_url: baseApiUrl
            };
        }
        return Locals.configData;
    }
}

export default Locals;
